import { useState } from "react";
import "@/App.css";
import { 
  Phone, MapPin, Clock, Truck, Car, Calculator, CheckCircle2, 
  AlertTriangle, Fuel, Battery, Wrench, Navigation as NavIcon, Users,
  Euro, ArrowRight, Menu, X, Mail, Gauge, Shield, Star, Quote,
  Instagram, Facebook, ExternalLink, MessageCircle, Play, Youtube, ChevronDown
} from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Images - All real photos from ZIZ Automobile (30+ photos)
const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/5k3c71dw_logo%20ZIZ%20automobile.jpg",
  
  // Hero & Featured
  hero: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/io9iu7kz_WhatsApp%20Image%202025-08-14%20at%2013.08.21_5cd506c7.jpg",
  
  // NEW - For Featured Mustang (full view with platform)
  mustangFeatured: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/dizv0uwm_WhatsApp%20Image%202026-02-04%20at%2018.59.33.jpeg",
  
  // Summer/Good Weather
  mustangOrlen: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/qu5m4kp2_WhatsApp%20Image%202026-02-04%20at%2018.59.32.jpeg",
  audiOrlenBlue: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/io9iu7kz_WhatsApp%20Image%202025-08-14%20at%2013.08.21_5cd506c7.jpg",
  audiPump: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/rej23pds_WhatsApp%20Image%202026-02-04%20at%2018.59.32.jpeg",
  platformVillage: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/cf9j1i12_WhatsApp%20Image%202026-02-04%20at%2018.59.33%20%281%29.jpeg",
  daciaLogan: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/i552rzkk_WhatsApp%20Image%202026-02-04%20at%2018.59.33%20%282%29.jpeg",
  audiCaravan: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/roishl2r_WhatsApp%20Image%202026-02-04%20at%2018.59.33%20%283%29.jpeg",
  platformTM17: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/k0uahatz_WhatsApp%20Image%202026-02-04%20at%2018.59.34%20%281%29.jpeg",
  fiestaRed: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/ssiu4dod_WhatsApp%20Image%202026-02-04%20at%2018.59.34.jpeg",
  mustangRoad: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/rej23pds_WhatsApp%20Image%202026-02-04%20at%2018.59.32.jpeg",
  mustangStation: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/dizv0uwm_WhatsApp%20Image%202026-02-04%20at%2018.59.33.jpeg",
  bmwX3Loading: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/bbipjp5c_WhatsApp%20Image%202026-02-04%20at%2018.59.21%20%281%29.jpeg",
  bmwX3Loaded: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/2dgo3hb1_WhatsApp%20Image%202026-02-04%20at%2018.59.21.jpeg",
  mustangDelivery: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/55okapym_WhatsApp%20Image%202026-02-04%20at%2018.59.31%20%285%29.jpeg",
  mustangITP: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/6hq59o39_WhatsApp%20Image%202026-02-04%20at%2018.59.31.jpeg",
  peugeot508: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/93ayteow_WhatsApp%20Image%202026-02-04%20at%2018.59.29%20%282%29.jpeg",
  
  // Rain/Bad Weather
  platformRain: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/ms226zp7_WhatsApp%20Image%202026-02-04%20at%2018.59.27.jpeg",
  vulcanizareRain: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/5vvi6jnc_WhatsApp%20Image%202026-02-04%20at%2018.59.33.jpeg",
  
  // Winter/Snow
  mercedesSnow: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/fn026hgz_WhatsApp%20Image%202026-02-04%20at%2018.59.28.jpeg",
  audiSnow: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/wx1g91e1_WhatsApp%20Image%202026-02-04%20at%2018.59.29%20%281%29.jpeg",
  mercedesSnow2: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/qab5itr5_WhatsApp%20Image%202026-02-04%20at%2018.59.29.jpeg",
  
  // Night
  bmwX3Night: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/86ypbw3m_WhatsApp%20Image%202026-02-04%20at%2018.59.25.jpeg",
  
  // Platform Views
  platformRear: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/4qg3h5vp_WhatsApp%20Image%202025-08-14%20at%2013.27.07_dd1fb19d.jpg",
  platformOperator: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/zwwl5b5q_WhatsApp%20Image%202026-02-04%20at%2018.59.21%20%282%29.jpeg",
  mustangRamps: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/ltyr5ric_WhatsApp%20Image%202026-02-04%20at%2018.59.29%20%283%29.jpeg",
  
  // NEW photos for gallery symmetry
  audiPlatformBlue: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/0ugiwsni_WhatsApp%20Image%202025-08-14%20at%2013.27.06_d797635b.jpg",
  platformTM17Rear: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/toitkrcy_WhatsApp%20Image%202026-02-04%20at%2018.59.34%20%281%29.jpeg",
  audiMountain: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/hzvqtygk_WhatsApp%20Image%202026-02-04%20at%2019.00.43%20%283%29.jpeg",
  audiWhiteBuilding: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/o3fk3nzu_WhatsApp%20Image%202025-08-14%20at%2013.27.04_bce313d0.jpg",
};

// Videos
const VIDEOS = {
  video1: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/32y9bz99_WhatsApp%20Video%202026-02-04%20at%2018.59.21.mp4",
  video2: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/q6xkp085_WhatsApp%20Video%202026-02-04%20at%2018.59.24.mp4",
  video3: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/uhb03o2d_WhatsApp%20Video%202026-02-04%20at%2018.59.29.mp4",
  video4: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/b77y2mq3_WhatsApp%20Video%202026-02-04%20at%2018.59.31.mp4",
  video5: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/is6y0ibp_WhatsApp%20Video%202026-02-04%20at%2019.00.41.mp4",
  video6: "https://customer-assets.emergentagent.com/job_auto-rescue-it/artifacts/oit1b3zf_WhatsApp%20Video%202026-02-04%20at%2021.36.04.mp4",
};

// Social Media Links - CORRECT LINKS
const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/ziz_automobile/",
  facebook: "https://www.facebook.com/zizautomobile",
  tiktok: "https://www.tiktok.com/@ziz_automobile",
  youtube: "https://www.youtube.com/@zizautomobile5700",
  google: "https://g.page/r/CaeQncKeC88REAE/review",
  whatsapp: "https://wa.me/40742071291",
};

// Custom SVG Logo Component - Z negru, I roșu, în cerc volan
const ZIZLogo = ({ size = "normal", showText = true }) => {
  // Logo FOARTE MARE pentru header
  const dimensions = size === "small" ? "w-16 h-16" : size === "large" ? "w-48 h-48" : "w-32 h-32";
  const textSize = size === "small" ? "text-2xl" : size === "large" ? "text-6xl" : "text-6xl";
  const subtextSize = size === "large" ? "text-lg" : "text-base";
  
  return (
    <div className="flex items-center gap-3">
      {/* Logo Icon - Cerc ca volan cu ZIZ */}
      <div className={`${dimensions} relative flex items-center justify-center`}>
        <img 
          src={IMAGES.logo}
          alt="ZIZ Automobile Logo"
          className="w-full h-full object-contain"
        />
      </div>
      {showText && (
        <div>
          <span className={`font-extrabold ${textSize} tracking-tight flex items-center`}>
            <span className="text-black">Z</span>
            <span className="text-[#DC2626]">I</span>
            <span className="text-black">Z</span>
          </span>
          <span className={`block ${subtextSize} text-gray-500 uppercase tracking-widest`}>Automobile</span>
        </div>
      )}
    </div>
  );
};

// TikTok Icon (not in lucide-react)
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
  </svg>
);

// Navigation Component
const Navigation = ({ isOpen, setIsOpen }) => {
  const navLinks = [
    { label: "Servicii", href: "#servicii" },
    { label: "Calculator", href: "#calculator" },
    { label: "Galerie", href: "#galerie" },
    { label: "Recenzii", href: "#recenzii" },
    { label: "FAQ", href: "#faq" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-36">
          <ZIZLogo size="normal" />
          
          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-gray-700 hover:text-[#DC2626] font-medium transition-colors duration-150"
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href={SOCIAL_LINKS.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-full flex items-center gap-2 font-semibold transition-all"
              data-testid="nav-whatsapp-btn"
            >
              <MessageCircle className="w-5 h-5" />
              WhatsApp
            </a>
            <a
              href="tel:+40742071291"
              className="btn-primary flex items-center gap-2"
              data-testid="nav-call-btn"
            >
              <Phone className="w-5 h-5" />
              Sună Acum
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2"
            data-testid="mobile-menu-btn"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setIsOpen(false)}
                className="block text-gray-700 hover:text-[#DC2626] font-medium py-2"
              >
                {link.label}
              </a>
            ))}
            <a
              href={SOCIAL_LINKS.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white w-full py-3 rounded-lg flex items-center justify-center gap-2 font-semibold"
            >
              <MessageCircle className="w-5 h-5" />
              WhatsApp
            </a>
            <a
              href="tel:+40742071291"
              className="btn-primary w-full flex items-center justify-center gap-2"
            >
              <Phone className="w-5 h-5" />
              Sună Acum
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

// Hero Section
const HeroSection = () => (
  <section className="relative min-h-screen pt-40 bg-gradient-to-br from-gray-50 to-white overflow-hidden">
    {/* Background Pattern - pointer-events-none pentru a nu bloca butoanele */}
    <div className="absolute inset-0 opacity-5 pointer-events-none">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-[#DC2626]" style={{ clipPath: 'polygon(30% 0, 100% 0, 100% 100%, 0 100%)' }} />
    </div>
    
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
        <div className="space-y-6">
          {/* 3 Main Services Badges */}
          <div className="flex flex-wrap gap-2">
            <div className="inline-flex items-center gap-2 bg-[#DC2626] text-white px-4 py-2 rounded-full">
              <Truck className="w-4 h-4" />
              <span className="text-sm font-bold">TRACTĂRI AUTO 24/7</span>
            </div>
            <div className="inline-flex items-center gap-2 bg-black text-white px-4 py-2 rounded-full">
              <Car className="w-4 h-4" />
              <span className="text-sm font-bold">IMPORT AUTO PE COMANDĂ</span>
            </div>
            <div className="inline-flex items-center gap-2 bg-gray-700 text-white px-4 py-2 rounded-full">
              <NavIcon className="w-4 h-4" />
              <span className="text-sm font-bold">TRANSPORT AUTO EUROPA</span>
            </div>
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight" data-testid="hero-title">
            TRACTĂRI AUTO<br />
            <span className="text-[#DC2626]">TIMIȘOARA</span><br />
            <span className="text-[#DC2626]">NON-STOP 24/7</span>
          </h1>
          
          <p className="text-xl text-gray-600 max-w-lg">
            <strong>Tractări auto</strong>, <strong>asistență rutieră urgentă</strong>, <strong>transport pe platformă</strong> și <strong>import auto din Germania</strong>. 
            Intervenție rapidă în Timișoara, Banat și oriunde în Europa. Platformă profesională 3500kg cu troliu.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="tel:+40742071291"
              className="bg-[#DC2626] hover:bg-red-700 text-white font-bold uppercase tracking-wider px-8 py-4 rounded-full flex items-center justify-center gap-3 text-lg transition-all shadow-lg hover:shadow-xl"
              data-testid="hero-call-btn"
            >
              <Phone className="w-6 h-6" />
              +40 742 071 291
            </a>
            <a
              href={SOCIAL_LINKS.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white font-bold uppercase tracking-wider px-8 py-4 rounded-full flex items-center justify-center gap-3 text-lg transition-all shadow-lg hover:shadow-xl"
              data-testid="hero-whatsapp-btn"
            >
              <MessageCircle className="w-6 h-6" />
              WhatsApp
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap gap-6 pt-4">
            {[
              { icon: <CheckCircle2 className="w-5 h-5 text-green-500" />, text: "Prețuri transparente" },
              { icon: <Truck className="w-5 h-5 text-[#DC2626]" />, text: "Platformă profesională" },
              { icon: <MapPin className="w-5 h-5 text-blue-500" />, text: "Acoperire europeană" },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2 text-sm text-gray-600">
                {item.icon}
                <span>{item.text}</span>
              </div>
            ))}
          </div>

          {/* Social Media */}
          <div className="flex items-center gap-4 pt-2">
            <span className="text-sm text-gray-500">Urmărește-ne:</span>
            <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-pink-500 transition-colors">
              <Instagram className="w-6 h-6" />
            </a>
            <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600 transition-colors">
              <Facebook className="w-6 h-6" />
            </a>
            <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-black transition-colors">
              <TikTokIcon className="w-6 h-6" />
            </a>
            <a href={SOCIAL_LINKS.youtube} target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-red-600 transition-colors">
              <Youtube className="w-6 h-6" />
            </a>
          </div>
        </div>

        {/* Right - Image */}
        <div className="relative">
          <div className="relative z-10 rounded-lg overflow-hidden shadow-2xl">
            <img
              src={IMAGES.hero}
              alt="ZIZ Automobile - Platformă Audi Q7 cu remorcă Wiola"
              className="w-full h-auto object-cover"
              data-testid="hero-image"
            />
          </div>
          {/* Decorative Elements */}
          <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#DC2626] rounded-lg -z-10" />
          <div className="absolute -top-6 -left-6 w-24 h-24 border-4 border-black rounded-lg -z-10" />
          
          {/* Price Badge - moved to top right to not cover phone number */}
          <div className="absolute -top-4 right-4 bg-black text-white px-6 py-4 rounded-lg shadow-xl z-20">
            <div className="text-center">
              <span className="text-3xl font-extrabold text-[#DC2626]">0.50€</span>
              <span className="block text-sm text-gray-400">/km</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// Services Section
const ServicesSection = () => {
  const services = [
    {
      icon: <Truck className="w-8 h-8" />,
      title: "Tractare & Remorcare 24h",
      description: "Transport auto pe platformă profesională Wiola de 3500kg cu troliu. Disponibil non-stop în Timișoara, Banat și Europa."
    },
    {
      icon: <Car className="w-8 h-8" />,
      title: "Import Auto pe Comandă",
      description: "Călătorești cu noi în Europa, verificăm împreună mai multe mașini până găsești ce îți dorești. Verificare vizuală, funcțională, tester strat vopsea și diagnoză OBD - toate incluse în prețul de transport dus-întors!"
    },
    {
      icon: <NavIcon className="w-8 h-8" />,
      title: "Transport Auto Europa & SUA",
      description: "Aducem mașini din Germania, Austria, Italia, Ungaria, Polonia și orice țară europeană. Import din SUA prin colaboratori - mașini prin licitații aduse pe container până în Olanda, apoi transportate la client.",
      link: "https://bid.cars/en/",
      linkText: "bid.cars"
    },
    {
      icon: <Wrench className="w-8 h-8" />,
      title: "Transport Dezmembrări",
      description: "Ducem mașinile către parcuri de dezmembrare din Timișoara și împrejurimi."
    },
    {
      icon: <Battery className="w-8 h-8" />,
      title: "Pornire Baterie",
      description: "Pornire cu cabluri sau înlocuire baterie de la service-uri partenere sau benzinării."
    },
    {
      icon: <Fuel className="w-8 h-8" />,
      title: "Alimentare Combustibil",
      description: "Ai rămas fără benzină? Venim cu combustibil direct la locația ta."
    },
    {
      icon: <Gauge className="w-8 h-8" />,
      title: "Verificare Auto",
      description: "Tester OBD2 și verificare strat vopsea pentru achiziții auto în siguranță."
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Transport pe Comandă",
      description: "Transport personalizat moto și obiecte lungi până la 8.5m (țevi, accesorii agricole, etc.) oriunde în România și Europa."
    },
  ];

  return (
    <section id="servicii" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Featured Image - Mustang */}
        <div className="mb-12">
          <div className="relative rounded-xl overflow-hidden shadow-2xl max-w-4xl mx-auto">
            <img 
              src={IMAGES.mustangOrlen}
              alt="Ford Mustang pe platformă ZIZ Automobile - Transport auto premium"
              className="w-full h-auto max-h-[500px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent">
              <div className="absolute bottom-6 left-6 right-6">
                <p className="text-white text-2xl font-bold">Transport Auto Premium</p>
                <p className="text-gray-300">Mașini de lux transportate cu grijă maximă</p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-16">
          <h2 className="section-title" data-testid="services-title">
            SERVICII DE TRACTĂRI AUTO<br />
            <span className="text-[#DC2626]">TIMIȘOARA ȘI JUDEȚUL TIMIȘ</span>
          </h2>
          <p className="section-subtitle mx-auto">
            Oferim tractări auto non-stop, platformă auto 24/7, asistență rutieră urgentă și transport auto pe platformă în Timișoara, Banat și Europa
          </p>
        </div>

        {/* Grid 4x2 - toate egale */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card bg-white hover:bg-gray-50"
              data-testid={`service-card-${index}`}
            >
              <div className="service-icon text-[#DC2626] mb-4 transition-all duration-300">
                {service.icon}
              </div>
              <h3 className="text-lg font-bold mb-2">{service.title}</h3>
              <p className="text-gray-600 text-sm">{service.description}</p>
              {service.link && (
                <a 
                  href={service.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 mt-2 text-[#DC2626] hover:underline text-sm font-semibold"
                >
                  Vezi {service.linkText} <ExternalLink className="w-3 h-3" />
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Calculator Section - simplu, fără API
const CalculatorSection = () => {
  const [pickupCity, setPickupCity] = useState('');
  const [distance, setDistance] = useState('');
  const [result, setResult] = useState(null);

  const PRICE_PER_KM = 0.50;
  const MIN_PRICE = 80;

  const calculatePrice = () => {
    const km = parseFloat(distance);
    if (isNaN(km) || km <= 0) {
      setResult({ error: 'Introduceți o distanță validă' });
      return;
    }

    const totalKm = km * 2;
    const price = Math.max(totalKm * PRICE_PER_KM, MIN_PRICE);

    setResult({
      distance: km,
      totalKm: totalKm,
      price: Math.round(price),
      pricePerKm: PRICE_PER_KM
    });
  };

  return (
    <section id="calculator" className="py-20 lg:py-32 bg-[#0f0f0f] noise-overlay">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Info */}
          <div className="text-white space-y-6">
            <h2 className="section-title !text-white" data-testid="calculator-title">
              CALCULATOR<br />
              <span className="text-[#DC2626]">PREȚ TRANSPORT</span>
            </h2>
            <p className="text-xl text-gray-300">
              Calculează rapid costul transportului. Prețul include deplasarea din 
              <strong className="text-white"> Timișoara</strong> până la locația ta și înapoi, 
              <strong className="text-white"> plus verificarea mașinii</strong>: inspecție vizuală, 
              verificare funcțională, tester strat vopsea și diagnoză OBD pentru eventuale erori - 
              toate la fața locului unde găsim mașina dorită.
            </p>
            
            <div className="space-y-4 pt-4">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-[#DC2626] rounded-full flex items-center justify-center">
                  <Euro className="w-6 h-6 text-white" />
                </div>
                <div>
                  <span className="text-2xl font-bold">0.50€/km</span>
                  <span className="block text-gray-400">Tarif standard</span>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <MapPin className="w-6 h-6 text-[#DC2626]" />
                </div>
                <div>
                  <span className="text-lg font-semibold">Plecare din Timișoara</span>
                  <span className="block text-gray-400">Către oriunde în Europa</span>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <Shield className="w-6 h-6 text-green-500" />
                </div>
                <div>
                  <span className="text-lg font-semibold">Preț minim 80€</span>
                  <span className="block text-gray-400">Pentru distanțe scurte</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Calculator Form */}
          <div className="bg-white rounded-lg shadow-2xl p-8 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#DC2626]/5 rounded-bl-full" />
            
            <h3 className="text-2xl font-bold mb-6">Calculează Acum</h3>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Oraș ridicare mașină
                </label>
                <input
                  type="text"
                  value={pickupCity}
                  onChange={(e) => setPickupCity(e.target.value)}
                  placeholder="ex: München, Germania"
                  className="input-field"
                  data-testid="calc-pickup-city"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Distanță (km) până la Timișoara
                </label>
                <input
                  type="number"
                  value={distance}
                  onChange={(e) => setDistance(e.target.value)}
                  placeholder="ex: 550 (verifică pe Google Maps)"
                  className="input-field"
                  data-testid="calc-distance"
                />
                <p className="text-xs text-gray-500 mt-1">
                  💡 Folosește <a href="https://www.google.com/maps" target="_blank" rel="noopener noreferrer" className="text-[#DC2626] underline">Google Maps</a> pentru distanță exactă
                </p>
              </div>

              <button
                onClick={calculatePrice}
                className="btn-primary w-full flex items-center justify-center gap-2"
                data-testid="calc-submit-btn"
              >
                <Calculator className="w-5 h-5" />
                Calculează Prețul
              </button>

              {result && (
                <div className="mt-6 p-6 bg-gray-50 rounded-lg" data-testid="calc-result">
                  {result.error ? (
                    <p className="text-red-600 flex items-center gap-2">
                      <AlertTriangle className="w-5 h-5" />
                      {result.error}
                    </p>
                  ) : (
                    <div className="space-y-3">
                      <div className="flex justify-between text-gray-600">
                        <span>Distanță dus:</span>
                        <span className="font-semibold">{result.distance} km</span>
                      </div>
                      <div className="flex justify-between text-gray-600">
                        <span>Total (dus-întors):</span>
                        <span className="font-semibold">{result.totalKm} km</span>
                      </div>
                      <div className="flex justify-between text-gray-600">
                        <span>Tarif/km:</span>
                        <span className="font-semibold">{result.pricePerKm}€</span>
                      </div>
                      <div className="border-t border-gray-200 pt-3 mt-3">
                        <div className="flex justify-between items-center">
                          <span className="text-lg font-bold">Preț estimat:</span>
                          <span className="text-3xl font-extrabold text-[#DC2626]">{result.price}€</span>
                        </div>
                      </div>
                      <p className="text-xs text-gray-500 mt-2">
                        * Prețul final poate varia în funcție de condițiile specifice
                      </p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Gallery Section - All Real Photos organized by conditions
const GallerySection = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState(null);

  const openLightbox = (img) => {
    setLightboxImage(img);
    setLightboxOpen(true);
  };

  // Featured photos for main gallery
  const featuredPhotos = [
    { src: IMAGES.audiOrlenBlue, alt: "Audi Q7 + Ford Mustang la Orlen - cer senin", category: "featured" },
    { src: IMAGES.mercedesSnow, alt: "Mercedes CLK Cabrio - transport iarna în zăpadă ❄️", category: "winter" },
    { src: IMAGES.platformRain, alt: "Tractări auto pe ploaie - disponibil 24/7 🌧️", category: "rain" },
    { src: IMAGES.bmwX3Night, alt: "BMW X3 - transport auto noaptea 🌙", category: "night" },
    { src: IMAGES.fiestaRed, alt: "Ford Fiesta pe platformă Wiola", category: "summer" },
    { src: IMAGES.mustangOrlen, alt: "Ford Mustang pe platformă la Orlen", category: "summer" },
  ];

  // All photos grid - 16 photos for 4x4 symmetric grid
  const allPhotos = [
    { src: IMAGES.audiPump, alt: "Audi Q7 TM 87 ZIZ la benzinărie" },
    { src: IMAGES.daciaLogan, alt: "Dacia Logan pe platformă" },
    { src: IMAGES.audiCaravan, alt: "Audi Q7 cu rulotă - transport versatil" },
    { src: IMAGES.peugeot508, alt: "Peugeot 508 pe platformă Wiola" },
    { src: IMAGES.bmwX3Loading, alt: "BMW X3 - încărcare pe platformă" },
    { src: IMAGES.mustangDelivery, alt: "Ford Mustang - livrare la client" },
    { src: IMAGES.platformVillage, alt: "Platformă Wiola goală" },
    { src: IMAGES.mustangITP, alt: "Ford Mustang la ITP" },
    { src: IMAGES.audiSnow, alt: "Audi Q7 în zăpadă - tractări iarna" },
    { src: IMAGES.mercedesSnow2, alt: "Mercedes CLK noapte de iarnă" },
    { src: IMAGES.vulcanizareRain, alt: "Transport auto pe ploaie" },
    { src: IMAGES.platformRear, alt: "Platformă TM 17 ZIZ - vedere spate" },
    { src: IMAGES.audiPlatformBlue, alt: "Audi Q7 cu platformă - cer albastru" },
    { src: IMAGES.platformTM17Rear, alt: "Platformă TM 17 ZIZ în sat" },
    { src: IMAGES.audiMountain, alt: "Audi Q7 cu platformă - seară" },
    { src: IMAGES.audiWhiteBuilding, alt: "Audi Q7 cu platformă" },
  ];

  return (
    <section id="galerie" className="py-20 lg:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="section-title" data-testid="gallery-title">GALERIE FOTO & VIDEO</h2>
          <p className="section-subtitle mx-auto">
            Lucrăm în orice condiții: vară ☀️, iarnă ❄️, ploaie 🌧️, noapte 🌙
          </p>
        </div>

        {/* Weather Badges */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          <span className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full text-sm font-semibold">☀️ Vară</span>
          <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-semibold">❄️ Iarnă</span>
          <span className="bg-gray-200 text-gray-800 px-4 py-2 rounded-full text-sm font-semibold">🌧️ Ploaie</span>
          <span className="bg-purple-100 text-purple-800 px-4 py-2 rounded-full text-sm font-semibold">🌙 Noapte</span>
          <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-semibold">✓ 24/7 Non-Stop</span>
        </div>

        {/* Featured Photos Grid - Click to open full image */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
          {featuredPhotos.map((img, index) => (
            <div 
              key={index} 
              className={`relative group rounded-lg overflow-hidden shadow-lg cursor-pointer ${index === 0 ? 'md:col-span-2 md:row-span-2' : ''}`}
              onClick={() => openLightbox(img)}
            >
              <img
                src={img.src}
                alt={img.alt}
                className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${index === 0 ? 'h-full min-h-[350px]' : 'h-56'}`}
                data-testid={`gallery-featured-${index}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent">
                <div className="absolute bottom-3 left-3 right-3 text-white">
                  <p className="font-semibold text-sm drop-shadow-lg">{img.alt}</p>
                </div>
              </div>
              <div className="absolute top-3 right-3 bg-white/80 text-gray-800 px-2 py-1 rounded text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity">
                Click pentru mărit
              </div>
            </div>
          ))}
        </div>

        {/* Videos Section - 3x2 centered - mai mari */}
        <div className="mb-12">
          <h3 className="text-3xl font-bold text-center mb-8">🎬 Video-uri în Acțiune</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {Object.values(VIDEOS).map((video, index) => (
              <div key={index} className="relative rounded-xl overflow-hidden shadow-2xl bg-black aspect-video">
                <video
                  src={video}
                  className="w-full h-full object-cover"
                  muted
                  loop
                  playsInline
                  autoPlay
                  data-testid={`gallery-video-${index}`}
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-4">
                  <p className="text-white text-base font-semibold">Video {index + 1}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* All Photos Grid - 4x4 symmetric */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-10">
          {allPhotos.map((img, index) => (
            <div 
              key={index} 
              className="relative group rounded-lg overflow-hidden shadow-md aspect-square cursor-pointer"
              onClick={() => openLightbox(img)}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                data-testid={`gallery-photo-${index}`}
              />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <p className="text-white text-xs text-center px-2">{img.alt}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox Modal */}
        {lightboxOpen && lightboxImage && (
          <div 
            className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
            onClick={() => setLightboxOpen(false)}
          >
            <button 
              className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300"
              onClick={() => setLightboxOpen(false)}
            >
              ×
            </button>
            <img 
              src={lightboxImage.src} 
              alt={lightboxImage.alt}
              className="max-w-full max-h-[90vh] object-contain rounded-lg"
            />
            <p className="absolute bottom-4 left-0 right-0 text-center text-white text-lg">
              {lightboxImage.alt}
            </p>
          </div>
        )}

        {/* Social Media CTA */}
        <div className="text-center bg-white rounded-xl p-8 shadow-lg">
          <p className="text-lg text-gray-700 mb-6">
            <strong>710+ urmăritori pe Facebook!</strong> Urmărește-ne pentru mai multe transporturi:
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href={SOCIAL_LINKS.facebook} 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-semibold"
              data-testid="gallery-facebook-btn"
            >
              <Facebook className="w-5 h-5" />
              Facebook (710+)
            </a>
            <a 
              href={SOCIAL_LINKS.tiktok} 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition-colors font-semibold"
              data-testid="gallery-tiktok-btn"
            >
              <TikTokIcon className="w-5 h-5" />
              @ziz_automobile
            </a>
            <a 
              href={SOCIAL_LINKS.instagram} 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-3 rounded-lg hover:opacity-90 transition-opacity font-semibold"
              data-testid="gallery-instagram-btn"
            >
              <Instagram className="w-5 h-5" />
              @ziz_automobile
            </a>
            <a 
              href={SOCIAL_LINKS.youtube} 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors font-semibold"
              data-testid="gallery-youtube-btn"
            >
              <Youtube className="w-5 h-5" />
              YouTube
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

// Testimonials Section
const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Alexandru M.",
      location: "Timișoara",
      rating: 5,
      text: "Serviciu excelent! Am rămas în pană pe autostradă la 2 noaptea și au venit în mai puțin de 60 de minute. Foarte profesioniști.",
      service: "Tractare de urgență"
    },
    {
      name: "Maria P.",
      location: "Arad",
      rating: 5,
      text: "Am folosit serviciul de import auto din Germania. Totul a decurs perfect, am călătorit împreună și mașina a ajuns în condiții excelente.",
      service: "Import auto Germania"
    },
    {
      name: "Cristian D.",
      location: "Lugoj",
      rating: 5,
      text: "Prețuri corecte și transparente. Au venit rapid să îmi tracteze mașina defectă. Recomand cu încredere!",
      service: "Tractare locală"
    },
    {
      name: "Elena S.",
      location: "Reșița",
      rating: 5,
      text: "Foarte mulțumită de serviciul de verificare auto. M-au ajutat să evit o țeapă la achiziția unei mașini second-hand.",
      service: "Verificare OBD2"
    },
  ];

  return (
    <section id="recenzii" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-title" data-testid="testimonials-title">CE SPUN CLIENȚII</h2>
          <p className="section-subtitle mx-auto">
            Recenzii de la clienții noștri mulțumiți
          </p>
          <a 
            href={SOCIAL_LINKS.google}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-4 text-[#DC2626] hover:underline font-semibold"
          >
            Vezi toate recenziile pe Google
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gray-50 p-6 rounded-lg relative"
              data-testid={`testimonial-${index}`}
            >
              <Quote className="w-8 h-8 text-[#DC2626]/20 absolute top-4 right-4" />
              
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              
              <p className="text-gray-600 mb-4 italic">"{testimonial.text}"</p>
              
              <div className="border-t border-gray-200 pt-4">
                <p className="font-bold">{testimonial.name}</p>
                <p className="text-sm text-gray-500">{testimonial.location}</p>
                <p className="text-xs text-[#DC2626] mt-1">{testimonial.service}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Social Media Live Feeds Section */}
        <div className="mt-20">
          <h3 className="text-3xl font-bold text-center mb-4" data-testid="social-feeds-title">
            📱 URMĂREȘTE-NE PE SOCIAL MEDIA
          </h3>
          <p className="text-center text-gray-600 mb-10">
            Conținut actualizat automat - vezi cele mai recente postări!
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
            {/* Facebook Feed - tot cardul clicabil */}
            <a 
              href="https://www.facebook.com/zizautomobile"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow cursor-pointer block"
              data-testid="facebook-feed"
            >
              <div className="bg-blue-600 text-white p-4 flex items-center gap-3">
                <Facebook className="w-6 h-6" />
                <div>
                  <p className="font-bold">Facebook</p>
                  <p className="text-xs text-blue-200">710+ urmăritori</p>
                </div>
              </div>
              <div className="p-4 h-[300px] flex flex-col items-center justify-center bg-gray-50">
                <Facebook className="w-16 h-16 text-blue-600 mb-4" />
                <p className="text-center text-gray-600 mb-4">
                  Vezi ultimele postări pe Facebook
                </p>
                <span className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold">
                  Deschide Facebook
                </span>
                <p className="text-xs text-gray-400 mt-4 text-center">
                  710+ urmăritori • Activ din 2018
                </p>
              </div>
            </a>

            {/* Instagram Feed - tot cardul clicabil */}
            <a 
              href={SOCIAL_LINKS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow cursor-pointer block"
              data-testid="instagram-feed"
            >
              <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white p-4 flex items-center gap-3">
                <Instagram className="w-6 h-6" />
                <div>
                  <p className="font-bold">Instagram</p>
                  <p className="text-xs text-pink-200">@ziz_automobile</p>
                </div>
              </div>
              <div className="p-4 h-[300px] flex flex-col items-center justify-center bg-gray-50">
                <Instagram className="w-16 h-16 text-pink-500 mb-4" />
                <p className="text-center text-gray-600 mb-4">
                  Vezi ultimele postări pe Instagram
                </p>
                <span className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 py-3 rounded-lg font-semibold">
                  Deschide @ziz_automobile
                </span>
                <p className="text-xs text-gray-400 mt-4 text-center">
                  Postări noi apar automat pe feed
                </p>
              </div>
            </a>

            {/* TikTok Feed - tot cardul clicabil */}
            <a 
              href={SOCIAL_LINKS.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow cursor-pointer block"
              data-testid="tiktok-feed"
            >
              <div className="bg-black text-white p-4 flex items-center gap-3">
                <TikTokIcon className="w-6 h-6" />
                <div>
                  <p className="font-bold">TikTok</p>
                  <p className="text-xs text-gray-400">@ziz_automobile</p>
                </div>
              </div>
              <div className="p-4 h-[300px] flex flex-col items-center justify-center bg-gray-50">
                <TikTokIcon className="w-16 h-16 text-black mb-4" />
                <p className="text-center text-gray-600 mb-4">
                  Video-uri cu muzică și tractări live
                </p>
                <span className="bg-black text-white px-6 py-3 rounded-lg font-semibold">
                  Deschide @ziz_automobile
                </span>
                <p className="text-xs text-gray-400 mt-4 text-center">
                  Video-uri noi cu muzică energică
                </p>
              </div>
            </a>

            {/* Google Reviews Feed - tot cardul clicabil */}
            <a 
              href={SOCIAL_LINKS.google}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow cursor-pointer block"
              data-testid="google-feed"
            >
              <div className="bg-white border-b p-4 flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <svg viewBox="0 0 24 24" className="w-6 h-6">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                </div>
                <div>
                  <p className="font-bold text-gray-800">Google Reviews</p>
                  <div className="flex items-center gap-1">
                    <span className="text-yellow-500 font-bold">5.0</span>
                    <div className="flex">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} className="w-3 h-3 fill-yellow-400 text-yellow-400" />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-4 h-[300px] flex flex-col bg-gray-50">
                <div className="flex-1 space-y-2">
                  <div className="bg-white p-2 rounded-lg shadow-sm">
                    <div className="flex items-center gap-2 mb-1">
                      <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold text-xs">A</div>
                      <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-yellow-400 text-yellow-400" />)}</div>
                    </div>
                    <p className="text-xs text-gray-600">"Super serviciu!"</p>
                  </div>
                  <div className="bg-white p-2 rounded-lg shadow-sm">
                    <div className="flex items-center gap-2 mb-1">
                      <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center text-white font-bold text-xs">M</div>
                      <div className="flex">{[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-yellow-400 text-yellow-400" />)}</div>
                    </div>
                    <p className="text-xs text-gray-600">"Recomand!"</p>
                  </div>
                </div>
                <span className="mt-2 bg-white border-2 border-gray-200 text-gray-700 px-4 py-2 rounded-lg font-semibold text-center text-sm">
                  Vezi toate recenziile
                </span>
              </div>
            </a>

            {/* YouTube Feed - tot cardul clicabil */}
            <a 
              href={SOCIAL_LINKS.youtube}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow cursor-pointer block"
              data-testid="youtube-feed"
            >
              <div className="bg-red-600 text-white p-4 flex items-center gap-3">
                <Youtube className="w-6 h-6" />
                <div>
                  <p className="font-bold">YouTube</p>
                  <p className="text-xs text-red-200">8 video-uri • 1,675 vizualizări</p>
                </div>
              </div>
              <div className="p-4 h-[300px] flex flex-col items-center justify-center bg-gray-50">
                <Youtube className="w-16 h-16 text-red-600 mb-4" />
                <p className="text-center text-gray-600 mb-4">
                  Video-uri cu transporturi și tractări auto
                </p>
                <span className="bg-red-600 text-white px-6 py-3 rounded-lg font-semibold">
                  Abonează-te pe YouTube
                </span>
                <p className="text-xs text-gray-400 mt-4 text-center">
                  Activ din 2018 • Video-uri profesionale
                </p>
              </div>
            </a>
          </div>

          {/* Call to Action */}
          <div className="mt-10 text-center bg-gradient-to-r from-[#DC2626] to-red-700 rounded-xl p-8 text-white">
            <h4 className="text-2xl font-bold mb-2">Urmărește-ne pentru actualizări live!</h4>
            <p className="text-red-100 mb-6">
              Postăm zilnic video-uri și poze cu transporturile noastre
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" className="bg-white text-blue-600 px-6 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors flex items-center gap-2">
                <Facebook className="w-5 h-5" /> Facebook
              </a>
              <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" className="bg-white text-pink-600 px-6 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors flex items-center gap-2">
                <Instagram className="w-5 h-5" /> Instagram
              </a>
              <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer" className="bg-white text-black px-6 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors flex items-center gap-2">
                <TikTokIcon className="w-5 h-5" /> TikTok
              </a>
              <a href={SOCIAL_LINKS.youtube} target="_blank" rel="noopener noreferrer" className="bg-white text-red-600 px-6 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors flex items-center gap-2">
                <Youtube className="w-5 h-5" /> YouTube
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// About Section
const AboutSection = () => (
  <section id="despre" className="py-16 lg:py-24 bg-gray-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-8 items-center">
        {/* Image cu logo overlay */}
        <div className="relative">
          <img
            src={IMAGES.hero}
            alt="ZIZ Automobile - Audi Q7 cu platformă Wiola"
            className="rounded-lg shadow-xl w-full"
            data-testid="about-image"
          />
          {/* Logo overlay pe poză - în colțul din dreapta sus */}
          <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm rounded-xl p-4 shadow-lg">
            <div className="flex items-center gap-3">
              <img 
                src={IMAGES.logo}
                alt="ZIZ Logo"
                className="w-16 h-16 object-contain"
              />
              <div>
                <span className="text-3xl font-extrabold flex items-center">
                  <span className="text-black">Z</span>
                  <span className="text-[#DC2626]">I</span>
                  <span className="text-black">Z</span>
                </span>
                <span className="block text-xs text-gray-500 uppercase tracking-widest">Automobile</span>
              </div>
            </div>
          </div>
        </div>

        {/* Content - mai compact */}
        <div className="space-y-4">
          <p className="text-lg text-gray-600">
            Suntem o companie de asistență rutieră din <strong>Timișoara</strong>, specializată 
            în tractări auto, import mașini și transport vehicule în întreaga Europă.
          </p>
          
          <p className="text-gray-600">
            Dispunem de echipament profesional - <strong>Audi Q7</strong> cu platformă 
            <strong> Wiola de 3500kg</strong> echipată cu <strong>troliu</strong>, ceea ce ne 
            permite să transportăm vehicule până în 3 tone în condiții de siguranță maximă.
          </p>

          <div className="grid grid-cols-2 gap-6 pt-4">
            {[
              { value: "3500kg", label: "Capacitate max" },
              { value: "0.50€", label: "Per km" },
              { value: "24/7", label: "Disponibil" },
              { value: "Europa", label: "Acoperire" },
            ].map((stat, i) => (
              <div key={i} className="text-center p-4 bg-white rounded-lg shadow">
                <span className="block text-2xl font-extrabold text-[#DC2626]">{stat.value}</span>
                <span className="text-sm text-gray-600">{stat.label}</span>
              </div>
            ))}
          </div>

          <div className="pt-4">
            <h4 className="font-bold text-lg mb-3">Servicii speciale:</h4>
            <ul className="space-y-2">
              {[
                "Import auto pe comandă - clientul poate călători cu noi",
                "Verificare strat vopsea și diagnoză OBD2",
                "Transport către dezmembrări",
                "În curând: mașină la schimb"
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-2 text-gray-600">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// FAQ Section pentru SEO
const FAQSection = () => {
  const [openFaq, setOpenFaq] = useState(null);
  
  const faqs = [
    {
      question: "Cât costă o tractare auto în Timișoara?",
      answer: "Prețul pentru tractări auto în Timișoara începe de la 80€ (tarif minim) și se calculează la 0.50€/km pentru distanțe mai mari. Prețul include deplasarea dus-întors. Oferim prețuri corecte, comunicate de la început, fără costuri ascunse."
    },
    {
      question: "Cât de rapid puteți ajunge pentru o tractare de urgență?",
      answer: "În Timișoara, Giroc, Dumbrăvița, Ghiroda și împrejurimi, timpul mediu de intervenție este sub 60 de minute. Suntem disponibili non-stop 24/7, 365 de zile pe an, inclusiv noaptea, weekend și sărbători."
    },
    {
      question: "Ce tipuri de vehicule puteți tracta?",
      answer: "Dispunem de platformă profesională Wiola de 3500kg cu troliu. Tractăm: autoturisme, SUV-uri, 4x4, dube, utilitare, mașini electrice și motociclete. Capacitate maximă: 3 tone."
    },
    {
      question: "Tractare accident / avarie – ce includ serviciile?",
      answer: "Serviciile de tractare pentru accidente și avarii includ: intervenție rapidă la locul incidentului, încărcare sigură pe platformă cu troliu, transport la service sau locația dorită, asistență în completarea documentelor pentru asigurare."
    },
    {
      question: "Tractați SUV și autoutilitare? Ce greutăți?",
      answer: "Da, tractăm SUV-uri, 4x4, dube și autoutilitare. Platforma noastră Wiola are capacitate de 3500kg și poate transporta vehicule până la 3 tone în siguranță deplină."
    },
    {
      question: "Oferiți tractări auto pe autostrada A1?",
      answer: "Da, oferim tractări auto pe autostrada A1 (Timișoara-București), A3 (Transilvania), precum și pe toate drumurile naționale DN și autostrăzile din România și Europa."
    },
    {
      question: "Ce zone acoperiți cu tractări auto non-stop?",
      answer: "Acoperim non-stop: Timișoara, Giroc, Dumbrăvița, Moșnița Nouă, Ghiroda, Lugoj, Giarmata, Săcălaz, Sânmihaiu Român, Recaș, Nădlac, Caransebeș, tot județul Timiș, Banat, România și Europa pentru transporturi internaționale."
    },
    {
      question: "Oferiți transport auto intern și extern?",
      answer: "Da, oferim transport auto pe platformă atât intern (în România) cât și extern (Europa). Import auto din Germania, Austria, Italia cu verificare la fața locului (OBD2, tester vopsea)."
    }
  ];

  // Zone deservite pentru SEO local
  const zoneDeservite = [
    "Timișoara", "Giroc", "Dumbrăvița", "Moșnița Nouă", "Ghiroda", 
    "Lugoj", "Giarmata", "Săcălaz", "Sânmihaiu Român", "Recaș",
    "Nădlac", "Caransebeș", "Jimbolia", "Sânnicolau Mare"
  ];

  return (
    <section id="faq" className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="section-title" data-testid="faq-title">
            ÎNTREBĂRI<br />
            <span className="text-[#DC2626]">FRECVENTE</span>
          </h2>
          <p className="section-subtitle mx-auto">
            Răspunsuri la cele mai comune întrebări despre tractări auto Timișoara
          </p>
        </div>
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden"
            >
              <button
                onClick={() => setOpenFaq(openFaq === index ? null : index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
              >
                <span className="font-semibold text-gray-900 pr-4">{faq.question}</span>
                <ChevronDown 
                  className={`w-5 h-5 text-[#DC2626] transition-transform flex-shrink-0 ${openFaq === index ? 'rotate-180' : ''}`}
                />
              </button>
              {openFaq === index && (
                <div className="px-6 pb-4">
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Zone Deservite - SEO Local */}
        <div className="mt-12 bg-white rounded-xl shadow-md p-6">
          <h3 className="text-xl font-bold text-center mb-4">
            Tractări Auto Non-Stop în <span className="text-[#DC2626]">Județul Timiș</span>
          </h3>
          <p className="text-center text-gray-600 mb-4">
            Oferim servicii de tractări auto, platformă auto și asistență rutieră 24/7 în:
          </p>
          <div className="flex flex-wrap justify-center gap-2">
            {zoneDeservite.map((zona, i) => (
              <span 
                key={i}
                className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm hover:bg-[#DC2626] hover:text-white transition-colors cursor-default"
              >
                {zona}
              </span>
            ))}
          </div>
          <p className="text-center text-sm text-gray-500 mt-4">
            + toate localitățile din județul Timiș, Banat și transport auto în toată Europa
          </p>
        </div>
      </div>
    </section>
  );
};

// Contact Section
const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    location: '',
    service: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const services = [
    "Tractare și remorcare",
    "Transport auto internațional",
    "Transport către dezmembrare",
    "Pornire/înlocuire baterie",
    "Alimentare combustibil",
    "Transport către vulcanizare",
    "Verificare auto (OBD2/vopsea)",
    "Transport moto",
    "Altele"
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <section id="contact" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-title" data-testid="contact-title">CONTACTEAZĂ-NE</h2>
          <p className="section-subtitle mx-auto">
            Suntem aici să te ajutăm 24/7. Completează formularul sau sună direct.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Contact Info Cards */}
          <div className="space-y-4">
            <a
              href="tel:+40742071291"
              className="flex items-center gap-4 bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border-l-4 border-[#DC2626]"
              data-testid="contact-phone"
            >
              <div className="w-12 h-12 bg-[#DC2626] rounded-full flex items-center justify-center">
                <Phone className="w-6 h-6 text-white" />
              </div>
              <div>
                <span className="block text-sm text-gray-500">Telefon</span>
                <span className="text-lg font-bold">+40 742 071 291</span>
              </div>
            </a>

            <a
              href={SOCIAL_LINKS.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-4 bg-green-50 p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border-l-4 border-green-500"
              data-testid="contact-whatsapp"
            >
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                <MessageCircle className="w-6 h-6 text-white" />
              </div>
              <div>
                <span className="block text-sm text-gray-500">WhatsApp</span>
                <span className="text-lg font-bold text-green-600">Scrie-ne acum</span>
              </div>
            </a>

            <a
              href="mailto:zizautomobile@gmail.com"
              className="flex items-center gap-4 bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300"
              data-testid="contact-email"
            >
              <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center">
                <Mail className="w-6 h-6 text-white" />
              </div>
              <div>
                <span className="block text-sm text-gray-500">Email</span>
                <span className="text-lg font-bold">zizautomobile@gmail.com</span>
              </div>
            </a>

            <div className="flex items-center gap-4 bg-gray-50 p-6 rounded-lg shadow-md">
              <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center">
                <MapPin className="w-6 h-6 text-gray-700" />
              </div>
              <div>
                <span className="block text-sm text-gray-500">Locație</span>
                <span className="text-lg font-bold">Timișoara, România</span>
                <span className="block text-sm text-gray-500">Acoperire: Banat + Europa</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="bg-gray-50 p-6 rounded-lg shadow-md">
              <span className="block text-sm text-gray-500 mb-3">Social Media</span>
              <div className="flex gap-3">
                <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white hover:bg-blue-700 transition-colors">
                  <Facebook className="w-5 h-5" />
                </a>
                <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white hover:opacity-90 transition-opacity">
                  <Instagram className="w-5 h-5" />
                </a>
                <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-black rounded-full flex items-center justify-center text-white hover:bg-gray-800 transition-colors">
                  <TikTokIcon className="w-5 h-5" />
                </a>
                <a href={SOCIAL_LINKS.google} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center text-white hover:bg-red-600 transition-colors">
                  <Star className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-2 bg-gray-50 p-8 rounded-lg shadow-xl">
            {submitted ? (
              <div className="text-center py-12">
                <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto mb-4" />
                <h3 className="text-2xl font-bold mb-2">Mesaj Trimis!</h3>
                <p className="text-gray-600">Te vom contacta în cel mai scurt timp.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Nume *
                    </label>
                    <input
                      type="text"
                      required
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      className="input-field"
                      placeholder="Numele tău"
                      data-testid="contact-form-name"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Telefon *
                    </label>
                    <input
                      type="tel"
                      required
                      value={formData.phone}
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                      className="input-field"
                      placeholder="+40 7xx xxx xxx"
                      data-testid="contact-form-phone"
                    />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Locație
                    </label>
                    <input
                      type="text"
                      value={formData.location}
                      onChange={(e) => setFormData({...formData, location: e.target.value})}
                      className="input-field"
                      placeholder="Oraș / Adresă"
                      data-testid="contact-form-location"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Serviciu
                    </label>
                    <select
                      value={formData.service}
                      onChange={(e) => setFormData({...formData, service: e.target.value})}
                      className="input-field"
                      data-testid="contact-form-service"
                    >
                      <option value="">Alege serviciul...</option>
                      {services.map((s, i) => (
                        <option key={i} value={s}>{s}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Mesaj
                  </label>
                  <textarea
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    rows={4}
                    className="input-field !h-auto resize-none"
                    placeholder="Descrie situația ta..."
                    data-testid="contact-form-message"
                  />
                </div>

                <button
                  type="submit"
                  className="btn-primary w-full flex items-center justify-center gap-2"
                  data-testid="contact-form-submit"
                >
                  Trimite Mesajul
                  <ArrowRight className="w-5 h-5" />
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => (
  <footer className="bg-[#0f0f0f] text-white py-12 noise-overlay">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-4 gap-8">
        <div>
          {/* Logo for dark background */}
          <div className="flex items-center gap-3">
            <img 
              src={IMAGES.logo}
              alt="ZIZ Automobile Logo"
              className="w-14 h-14 object-contain"
            />
            <div>
              <span className="font-extrabold text-2xl tracking-tight flex items-center">
                <span className="text-white">Z</span>
                <span className="text-[#DC2626]">I</span>
                <span className="text-white">Z</span>
              </span>
              <span className="block text-xs text-gray-400 uppercase tracking-widest">Automobile</span>
            </div>
          </div>
          <p className="text-gray-400 mt-4">
            Asistență rutieră profesională în Timișoara, Banat și Europa.
          </p>
          {/* Social Links */}
          <div className="flex gap-3 mt-4">
            <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-500 transition-colors">
              <Facebook className="w-5 h-5" />
            </a>
            <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-pink-500 transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
              <TikTokIcon className="w-5 h-5" />
            </a>
            <a href={SOCIAL_LINKS.youtube} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-red-500 transition-colors">
              <Youtube className="w-5 h-5" />
            </a>
          </div>
        </div>
        
        <div>
          <h4 className="font-bold text-lg mb-4">Servicii</h4>
          <ul className="space-y-2 text-gray-400">
            <li>Tractare & Remorcare 24h</li>
            <li>Transport Europa</li>
            <li>Import Auto</li>
            <li>Verificare Auto</li>
          </ul>
        </div>
        
        <div>
          <h4 className="font-bold text-lg mb-4">Contact</h4>
          <ul className="space-y-2 text-gray-400">
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-[#DC2626]" />
              +40 742 071 291
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-[#DC2626]" />
              zizautomobile@gmail.com
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-[#DC2626]" />
              Timișoara, România
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-lg mb-4">Contact Rapid</h4>
          <a
            href={SOCIAL_LINKS.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg flex items-center justify-center gap-2 transition-colors"
          >
            <MessageCircle className="w-5 h-5" />
            WhatsApp
          </a>
        </div>
      </div>
      
      <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-500">
        <p>© {new Date().getFullYear()} ZIZ Automobile. Toate drepturile rezervate.</p>
      </div>
    </div>
  </footer>
);

// Floating Buttons (Call + WhatsApp)
const FloatingButtons = () => (
  <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
    {/* WhatsApp Button */}
    <a
      href={SOCIAL_LINKS.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110"
      data-testid="floating-whatsapp-btn"
      aria-label="WhatsApp"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
    
    {/* Call Button */}
    <a
      href="tel:+40742071291"
      className="floating-call-btn"
      data-testid="floating-call-btn"
      aria-label="Sună acum"
    >
      <Phone className="w-6 h-6 relative z-10" />
    </a>
  </div>
);

// Main App
function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="App">
      <Navigation isOpen={mobileMenuOpen} setIsOpen={setMobileMenuOpen} />
      <HeroSection />
      <ServicesSection />
      <CalculatorSection />
      <GallerySection />
      <TestimonialsSection />
      <AboutSection />
      <FAQSection />
      <ContactSection />
      <Footer />
      <FloatingButtons />
    </div>
  );
}

export default App;
